import script from "./AddObjectiveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddObjectiveModal.vue?vue&type=script&setup=true&lang=js"

import "./AddObjectiveModal.vue?vue&type=style&index=0&id=7b55d37e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b55d37e"]])

export default __exports__